/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, trackCrossPlatform } from "@packages/analytics";

import type { TranscriptData } from "../../../hooks/useTranscript";
import { VttSegmentRenderer } from "./VttSegmentRenderer.emotion";

const textStyle: Interpolation = {
  whiteSpace: "pre-line",
};

type TranscriptContentProps =
  | {
      transcriptData: TranscriptData | null;
      transcriptType: "txt";
    }
  | {
      transcriptData: TranscriptData | null;
      transcriptType: "vtt";
      currentTime: number;
    };

export const TranscriptContent = (props: TranscriptContentProps) => {
  const t = useTranslations();
  const { transcriptData, transcriptType } = props;

  if (!transcriptData || !transcriptData.textContent) {
    return <span css={textStyle}>{t("no_transcript_available_text")}</span>;
  }

  if (transcriptType === "txt") {
    return (
      <span
        css={textStyle}
        onPointerUp={() =>
          trackCrossPlatform({
            event: { event: HallowAnalyticsEvent.TappedTranscriptText },
          })
        }
      >
        {transcriptData.textContent}
      </span>
    );
  }

  if (
    transcriptType === "vtt" &&
    transcriptData.segments &&
    transcriptData.segments.length > 0
  ) {
    return (
      <VttSegmentRenderer
        segments={transcriptData.segments}
        currentTime={props.currentTime}
      />
    );
  }

  return <span css={textStyle}>{transcriptData.textContent}</span>;
};
